import { Bell, LogOut } from 'lucide-react'
import { useAuthStore } from '../stores/authStore'

interface HeaderProps {
  sidebarCollapsed: boolean
}

export default function Header({ sidebarCollapsed }: HeaderProps) {
  const { user, logout } = useAuthStore()

  const initials = user?.name
    ? user.name.split(' ').map((n) => n[0]).slice(0, 2).join('').toUpperCase()
    : '?'

  const greeting = () => {
    const hour = new Date().getHours()
    if (hour < 12) return 'Buenos días'
    if (hour < 18) return 'Buenas tardes'
    return 'Buenas noches'
  }

  return (
    <header
      className="fixed top-0 right-0 z-10 h-16 flex items-center px-6 transition-all duration-300"
      style={{
        left: sidebarCollapsed ? '72px' : '240px',
        background: 'rgba(10,15,30,0.85)',
        backdropFilter: 'blur(12px)',
        borderBottom: '1px solid rgba(255,255,255,0.06)',
      }}
    >
      {/* Left: greeting */}
      <div className="flex flex-col justify-center">
        <span className="text-sm font-semibold text-[#F1F5F9] leading-tight">
          {greeting()}, {user?.name?.split(' ')[0]} 👋
        </span>
        <span className="text-xs text-[#94A3B8] mt-0.5">
          Continúa donde lo dejaste
        </span>
      </div>

      {/* Right: actions */}
      <div className="ml-auto flex items-center space-x-2">
        {/* Notifications */}
        <button
          className="relative w-9 h-9 flex items-center justify-center rounded-xl transition-colors"
          style={{ color: '#94A3B8' }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = 'rgba(255,255,255,0.06)'
            e.currentTarget.style.color = '#F1F5F9'
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'transparent'
            e.currentTarget.style.color = '#94A3B8'
          }}
          aria-label="Notificaciones"
        >
          <Bell className="w-4 h-4" />
        </button>

        {/* Separator */}
        <div className="w-px h-5" style={{ background: 'rgba(255,255,255,0.1)' }} />

        {/* Avatar only — name+plan live in sidebar */}
        <div
          className="w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold text-white flex-shrink-0"
          title={user?.name}
          style={{ background: 'linear-gradient(135deg, #4F46E5, #8B5CF6)' }}
        >
          {initials}
        </div>

        {/* Separator */}
        <div className="w-px h-5" style={{ background: 'rgba(255,255,255,0.1)' }} />

        {/* Logout */}
        <button
          onClick={logout}
          className="w-9 h-9 flex items-center justify-center rounded-xl transition-colors"
          style={{ color: '#94A3B8' }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = 'rgba(244,63,94,0.1)'
            e.currentTarget.style.color = '#F43F5E'
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'transparent'
            e.currentTarget.style.color = '#94A3B8'
          }}
          title="Cerrar sesión"
        >
          <LogOut className="w-4 h-4" />
        </button>
      </div>
    </header>
  )
}
